export class ChapterReqModel {
    classId?: number;
    subject?: number;
    chapter?: number;

    constructor(classId?: number, subject?: number, chapter?: number) {
        this.classId = classId;
        this.subject = subject;
        this.chapter = chapter;
    }
}
